'use strict'

import React from 'react'

import './CardLinks.scss'

class CardLinks extends React.Component {
  render () {
    const ccn = 'card-links'
    return (
      <div className={ccn}>
        <h2 className={ccn + '__title'}>Manage your account - anytime, anywhere</h2>
        <div className={ccn + '__panel'}>
          <div className={ccn + '__placeholder'}>
            <a className={ccn + '__link button-link button-link--large'} target='_blank' href='https://www.myargoscard.co.uk/cards/security/logon/logon.aspx'>View your statements</a>
          </div>
          <div className={ccn + '__spacer'} />
          <div className={ccn + '__placeholder'}>
            <a className={ccn + '__link button-link button-link--large'} target='_blank' href='https://www.myargoscard.co.uk/cards/security/logon/logon.aspx'>Make payments</a>
          </div>
          <div className={ccn + '__spacer'} />
          <div className={ccn + '__placeholder'}>
            <a className={ccn + '__link button-link button-link--large'} target='_blank' href='https://www.myargoscard.co.uk/cards/security/logon/logon.aspx'>Set up a direct debit</a>
          </div>
          <div className={ccn + '__spacer'} />
          <div className={ccn + '__placeholder'}>
            <a className={ccn + '__link button-link button-link--large'} target='_blank' href='https://www.myargoscard.co.uk/cards/security/logon/logon.aspx'>Check your balance</a>
          </div>
        </div>
      </div>
    )
  }
}

export default CardLinks
